
import React, { useEffect, useState } from "react";
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle, 
  CardDescription 
} from "@/components/ui/card";
import { BarChart3 } from "lucide-react";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer 
} from "recharts";

interface UserMetricsChartProps {
  userMetrics: {
    name: string;
    value: number;
  }[];
}

const UserMetricsChart = ({ userMetrics }: UserMetricsChartProps) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading data for 2 seconds
    setTimeout(() => {
      setLoading(false); // Set loading to false after data is fetched
    }, 2000);
  }, []);

  if (loading) {
    return (
      <Card className="w-full h-full min-h-[400px]">
        <CardHeader>
          <CardTitle className="flex items-center">
            <BarChart3 className="mr-2 h-5 w-5 text-[#333B44]" />
            User Metrics
          </CardTitle>
          <CardDescription>
            Key metrics about system usage
          </CardDescription>
        </CardHeader>
        <CardContent className="h-full flex justify-center items-center">
          <div>Loading...</div> {/* Display loading state */}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="w-full h-full min-h-[400px]">
      <CardHeader>
        <CardTitle className="flex items-center">
          <BarChart3 className="mr-2 h-5 w-5 text-[#333B44]" />
          User Metrics
        </CardTitle>
        <CardDescription>
          Key metrics about system usage
        </CardDescription>
      </CardHeader>
      <CardContent className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={userMetrics}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 60,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="name" 
              angle={-45} 
              textAnchor="end" 
              height={60}
              interval={0}
              tick={{ fontSize: 12 }}
            />
            <YAxis 
              tickFormatter={(value) => Math.round(value).toString()}
              domain={[0, 'auto']}
            />
            <Tooltip formatter={(value) => [Math.round(Number(value) * 100) / 100, ""]} />
            <Legend verticalAlign="top" height={36} formatter={(value) => value} />
            <Bar 
              dataKey="value" 
              name="Count" 
              fill="#8884d8"
              maxBarSize={50}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default UserMetricsChart;
